import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LocalPartnerForm"] */ "/app/src/components/new/LocalPartner/LocalPartnerForm.tsx");
